import React, { useEffect, useRef } from 'react'

// Component
const Header = () => {
  // Name colors animation
  let name = useRef(null)
  let timerRef = useRef(null)
  let colorIndex = 0
  let colors = ['#ffffff', '#42dc8e', '#d51c69', '#ffe359']

  useEffect(() => {
    timerRef.current = setInterval(() => {
      name.style.color = colors[colorIndex]
      colorIndex = (colorIndex + 1) % colors.length
    }, 1100)
    return () => clearInterval(timerRef.current)
  })

  return (
    <div className="header">
      <div className="inner-header">
        <p className="name">
          <span className="name-intro">Hello, I&apos;m</span>
          <span className="name-inner" ref={el => (name = el)}>
            Pragun Saini
          </span>
        </p>
        <p className="name-desc">I am a Web Developer</p>
      </div>
      <a
        className="scroller"
        onClick={() => {
          document.getElementById('about').scrollIntoView()
        }}
      >
        Scroll
      </a>
    </div>
  )
}

export default Header
